import { UploadProcessDocument } from 'modules/documents/hooks/useGetUploadProcessDocuments'

export const uploadProcessDocumentsToMatches = (
  documentIds: number[],
  items: UploadProcessDocument[]
): Record<string, number[]> => {
  const filteredItems = items.filter(
    (item) => documentIds.includes(item.documentId) && !!item.matchedEmployeeId
  )

  return filteredItems.reduce((acc: { [key: number]: number[] }, item) => {
    if (!acc[item.documentId]) {
      acc[item.documentId] = []
    }

    const indexedItem = acc[item.documentId]

    if (indexedItem && item.matchedEmployeeId) {
      indexedItem.push(item.matchedEmployeeId)
    }

    return acc
  }, {})
}
